// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageSendBody = {
  chatId: string;
  requestId: string;
  kind: "text" | "poll" | "pdf" | "image" | "gif" | "gameCard";
  body?: string | null;
  replyToMessageId?: string | null;
  pollDraft?: {
    question: string;
    allowMultiple: boolean;
    optionLabels: string[];
  } | null;
  mediaObjectId?: string | null;
  mediaObjectIds?: string[] | null;
  gifObjectId?: string | null;
  gameCardEventId?: string | null;
  timeZone?: string | null;
};

export type typeMessageSendOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { messageId: string; sentAtIso: string };
};

export type typeMessageSendOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageSendOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageSendOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageSendBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
    kind: {
      type: "string",
      enum: ["text", "poll", "pdf", "image", "gif", "gameCard"],
    },
    body: {
      oneOf: [
        { type: "string", maxLength: 10000, minLength: 1 },
        { enum: [null] },
      ],
    },
    replyToMessageId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    pollDraft: {
      oneOf: [
        {
          type: "object",
          properties: {
            question: { type: "string", maxLength: 3000, minLength: 1 },
            allowMultiple: { type: "boolean" },
            optionLabels: {
              type: "array",
              items: { type: "string", maxLength: 3000, minLength: 1 },
            },
          },
          required: ["question", "allowMultiple", "optionLabels"],
        },
        { enum: [null] },
      ],
    },
    mediaObjectId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    mediaObjectIds: {
      oneOf: [
        {
          type: "array",
          items: { type: "string", maxLength: 3000, minLength: 1 },
        },
        { enum: [null] },
      ],
    },
    gifObjectId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    gameCardEventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    timeZone: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["chatId", "requestId", "kind"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageSend(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageSendBody);
  }

  return async function postMessageSend(
    payload: typeMessageSendBody,
  ): Promise<typeMessageSendOutput200 | typeMessageSendOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageSend" failed before calling the network. #ac1dcbc5e256`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ac1dcbc5e256" },
        },
        data: null,
      } as typeMessageSendOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message/send`,
      httpMethod: "POST",
      options,
    })) as typeMessageSendOutput200 | typeMessageSendOutput400;
  };
}
